import toast from "react-hot-toast";

const { clientAPI } = require("../client");

// Chấm công luồng mới - Bước 1: đăng ký thiết bị + địa điểm chấm công
const showError = (error) => {
  const errorMessages = error?.response?.data?.errors?.map(
    (err) => err.message,
  ) || [
    error?.response?.data?.message ||
      error?.response?.statusText ||
      error?.message ||
      "An unexpected error occurred.",
  ];

  errorMessages.forEach((message) => {
    toast.error(`${message}`);
  });
};

export const checkinV2Call = {
  deleteRegistration: async (id) => {
    try {
      return await clientAPI("delete", `/checkinV2/registrations/${id}`);
    } catch (error) {
      console.error("Delete registration error:", error);
      showError(error);
      throw error;
    }
  },

  handleRequest: async (id, data) => {
    try {
      return await clientAPI(
        "put",
        `/checkinV2/change-requests/${id}/handle`,
        data,
      );
    } catch (error) {
      console.error("Handle registration request error:", error);
      showError(error);
      throw error;
    }
  },

  // Hoàn tác đơn Không duyệt về Đang duyệt
  revertRequest: async (id) => {
    try {
      return await clientAPI("put", `/checkinV2/change-requests/${id}/revert`);
    } catch (error) {
      console.error("Revert registration request error:", error);
      showError(error);
      throw error;
    }
  },
};
